import api from '../axios';

export const AIAssistantService = {
    chat: (data) => api.post('assessments/ai-assistant/chat', data),
};

export const TemplateService = {
    list: () => api.get('templates/'),
    get: (id) => api.get(`templates/${id}/`),
};

export const ReportingService = {
    getFrameworkReadiness: (frameworkCode) => api.get(`reports/framework-readiness?framework_code=${frameworkCode}`),
};

export const ExportService = {
    exportPack: (data) => api.post('exports/policy-pack/', data),
};

/**
 * ComplianceService — deterministic API calls that never go through AI.
 * Maps directly to: /compliance/* backend routes.
 */
export const ComplianceService = {
    /** GET /compliance/readiness?framework=CMMC_L1 */
    getReadiness: (framework) => {
        const params = framework ? `?framework=${encodeURIComponent(framework)}` : '';
        return api.get(`compliance/readiness${params}`);
    },

    /** GET /compliance/gaps?framework=CMMC_L1 */
    getGaps: (framework) => {
        const params = framework ? `?framework=${encodeURIComponent(framework)}` : '';
        return api.get(`compliance/gaps${params}`);
    },

    /** GET /compliance/control/{control_id} */
    getControl: (controlId) => api.get(`compliance/control/${controlId}`),

    /** GET /compliance/controls/search?q=AC.L1-3.1.1&framework=CMMC_L1 */
    searchControls: (q, framework) => {
        const params = new URLSearchParams({ q });
        if (framework) params.set('framework', framework);
        return api.get(`compliance/controls/search?${params.toString()}`);
    },

    /** GET /compliance/report?framework=CMMC_L1 */
    getReport: (framework) => {
        const params = framework ? `?framework=${encodeURIComponent(framework)}` : '';
        return api.get(`compliance/report${params}`);
    },
};
